import { Util } from "../templates/Internals";
import { PIC } from "./PIC";
export function lowerCaseLocaleCompare(a, b, locale = 'da', options = { numeric: true }) {
    return a.toLowerCase().localeCompare(b.toLowerCase(), locale, options);
}
export const trimChars = (info, delimiter) => {
    if (typeof delimiter === 'string')
        delimiter = new RegExp(`^\\${delimiter}+|\\${delimiter}+$`, 'g');
    return info.replace(delimiter, '');
};
/**
 * Split common progress string into objects.
 * Currently handles specific delimiters, but should generally take all strings.
 * Beware commInfos/EXPinfos starting with an extra 0
 * @example infoString2Object(':x:1:y:50', 'EXP') // {x: 1, y: 50}
 * @param info
 * @param delimiter
 * @param subDelimiter
 * @returns
 */
export const infoString2Object = (info, delimiter, subDelimiter) => {
    if (delimiter === 'EXP')
        delimiter = ':';
    let delimiterRegEx = new RegExp(`^\\${delimiter}+|\\${delimiter}+$`, 'g');
    info = trimChars(info, delimiterRegEx);
    const resultObj = {};
    if (!subDelimiter) {
        let splitInfo = info.split(delimiter);
        for (let i = 0; i < splitInfo.length; i++) {
            if (i % 2 === 0)
                resultObj[splitInfo[i]] = '';
            else
                resultObj[splitInfo[i - 1]] = splitInfo[i];
        }
        return resultObj;
    }
    let splitInfo = info.split(delimiter);
    for (let i = 0; i < splitInfo.length; i++) {
        let innerInfo = splitInfo[i].split(subDelimiter);
        resultObj[innerInfo[0]] = innerInfo[1];
    }
    return resultObj;
};
export const __debug = () => sessionStorage.getItem('__debug') === 'true';
export const decodeText = (io, oEnc) => {
    let decoder = new TextDecoder(oEnc);
    let result = decoder.decode(io);
    return result;
};
export const decodeIso88591 = (io) => decodeText(io, 'iso-8859-1');
export const json2Formdata = (obj, convertValue) => {
    let formData = '';
    if (obj instanceof Map) {
        let sub = [];
        for (let [key, val] of obj) {
            let tmp = key;
            if (key.match(/_\w{8}-\w{4}-\w{4}-\w{4}-\w{12}$/) != null) {
                tmp = key.replace(/_\w{8}-\w{4}-\w{4}-\w{4}-\w{12}$/, '');
            }
            sub.push(`${tmp}=${val}`);
        }
        formData = sub.join('&');
    }
    else {
        formData = Object.entries(obj).map((entry) => {
            let name = entry[0];
            let value = typeof convertValue !== 'undefined' ? convertValue(entry[1]) : entry[1];
            return `${name}=${value}`;
        }).join('&');
    }
    return formData;
};
/**
 * Handles throttling of user events
 * @param func function to throttle
 * @param timeout function will only be called once per `time` ms
 */
export const _throttle = (bind, func, timeout, preventDefault) => {
    const throttleFunc = (event, ...args) => {
        var _a;
        if (preventDefault)
            event.preventDefault();
        bind[func.name].bind(bind, ...args);
        const expireTimeCurr = (_a = __throttledFunctions.get(func)) !== null && _a !== void 0 ? _a : 0;
        const currTime = new Date().getTime();
        if (currTime > expireTimeCurr) {
            bind[func.name](event, ...args); //call to function happens here
            const expireTimeNew = new Date();
            expireTimeNew.setTime(currTime + timeout);
            __throttledFunctions.set(func, expireTimeNew.getTime());
        }
        else {
            //do nothing
        }
    };
    return throttleFunc;
};
const __throttledFunctions = new Map();
/**
 * Creates a function that will run after `timeout`ms.
 * If called before the timeout it will not trigger.
 * @param func
 * @param timeout
 * @param options
 * @returns
 */
export const _debounce = (func, timeout, options) => {
    const debounceFunc = (event) => {
        if (options === null || options === void 0 ? void 0 : options.preventDefault)
            event.preventDefault();
        if (options === null || options === void 0 ? void 0 : options.bind)
            options.bind[func.name].bind(options.bind);
        if (__debouncedFunctions.has(func)) {
            clearTimeout(__debouncedFunctions.get(func));
        }
        const timeoutFunc = () => {
            __debouncedFunctions.delete(func);
            if (options === null || options === void 0 ? void 0 : options.bind)
                options.bind[func.name](event);
            else
                func();
        };
        const timeoutId = window.setTimeout(timeoutFunc, timeout);
        __debouncedFunctions.set(func, timeoutId);
    };
    return debounceFunc;
};
const __debouncedFunctions = new Map();
export function overrideConsoleLog() {
    // let funcs: (keyof Console)[] = ['assert', 'clear', 'group', 'groupCollapsed', 'groupEnd', 'log', 'table', 'time', 'timeEnd', 'timeLog', 'trace', 'warn'];
    // for(const func of funcs){
    //     let oldLog = console[func];
    //     //@ts-ignore
    //     console[func] = function (message) {
    //         PIC.consoleLog += message + '\n';  
    //         //@ts-ignore
    //         oldLog.apply(console, arguments);
    //     };
    // }
    function objToString(obj) {
        return Object.entries(obj).reduce((str, [p, val]) => {
            return `${str}${p}::${val}\n`;
        }, '');
    }
    // var getStackTrace = function() {
    //     var obj = {};
    //     //@ts-ignore
    //     Error.captureStackTrace(obj, getStackTrace);
    //     //@ts-ignore
    //     return obj.stack;
    //   };
    // function getStackTrace () {
    //     var stack;
    //     try {
    //       throw new Error('');
    //     }
    //     catch (error: any) {
    //       stack = error.stack || '';
    //     }
    //     // stack = stack.split('\n').map(function (line: string) { return line.trim(); });
    //     // return stack.splice(stack[0] == 'Error' ? 2 : 1);
    //     return stack;
    //   }
    function getStackTrace() {
        let stack;
        stack = new Error().stack;
        stack = stack === null || stack === void 0 ? void 0 : stack.split('\n').map(x => x).splice(stack[0] == 'Error' ? 2 : 1);
        return stack ? stack.join('\n\n') : '';
    }
    function getStackTrace2() {
        let stack;
        stack = new Error().stack;
        stack = stack === null || stack === void 0 ? void 0 : stack.split('\n').map(x => x).splice(stack[0] == 'Error' ? 2 : 1);
        return stack ? stack : [];
    }
    let map;
    function doURI(front, back) {
        let arr = location.hostname.split('.');
        arr[0] = front;
        return `${location.protocol}//${arr.join('.')}${back ? '/' + back : ''}`;
    }
    function getMap() {
        // if(!map)
        return fetch(`${doURI('udv', 'scripts/picit/picbundle.js.map')}`)
            .then(res => res.json())
            .catch(err => '');
        // return map;
    }
    async function doMapping(trace) {
        // let testStr = 'at e (https://udv.picit.dk/scripts/picit/test/picbundle-stk.js?v=47287747:2347:119714) at console. [as log] (https://udv.picit.dk/scripts/picit/test/picbundle-stk.js?v=47287747:2347:120023) at Object.parseLayout (https://udv.picit.dk/scripts/picit/test/picbundle-stk.js?v=47287747:1:33648) at loadWebMenu (https://udv.picit.dk/web/:7:38)';
        let resultStr = await getMap().then(data => {
            var _a, _b, _c;
            let m = data;
            //:name:mappings
            let atArr = (_b = (_a = trace.match(/(?<=at )(.*?) (?=\()/g)) === null || _a === void 0 ? void 0 : _a.map((x) => x.trim())) !== null && _b !== void 0 ? _b : [];
            let sourceStr = (_c = trace.match(/(?<= )\((.*?)(?=\))/g)) !== null && _c !== void 0 ? _c : [];
            let tagMap = sourceStr.map((str, idx) => {
                let URLArr = str.split('/');
                if (URLArr) {
                    let last = URLArr[URLArr.length - 1];
                    let placementArr = last === null || last === void 0 ? void 0 : last.split(':');
                    if (placementArr && placementArr.length > 1) {
                        let line = Number(placementArr[1]);
                        let col = Number(placementArr[2]);
                        return { atName: atArr[idx], line: line, column: col };
                    }
                }
                return { atName: '', line: -1, column: -1 };
            });
            let result = tagMap === null || tagMap === void 0 ? void 0 : tagMap.map(tm => {
                let name = m.names[tm.line];
                let mapping = m.mappings.split(',')[tm.column];
                let atIdx = m.sources.findIndex(x => tm.atName);
                let atSourceContent = '';
                if (atIdx && atIdx > -1)
                    atSourceContent = m.sourcesContent[atIdx];
                return `${JSON.stringify(tm)} \n at: ${name} in: ${mapping} of: ${atSourceContent}
                `;
            });
            return result;
        });
        return resultStr;
    }
    for (let func in console) {
        //@ts-ignore
        if (typeof console[func] === 'function') {
            if (func === 'trace')
                continue;
            //@ts-ignore
            let oldConsole = console[func];
            //@ts-ignore
            console[func] = function () {
                for (let arg of arguments) {
                    let argStr = typeof arg === 'object' ? objToString(arg) : arg;
                    // PIC.consoleLog.push({timeStamp: new Date(), type: func, message: argStr, trace: getStackTrace()});
                    // PIC.consoleLog.push({timeStamp: new Date(), type: func, message: arg, trace: doMapping(getStackTrace())});
                    // PIC.consoleLog.push({timeStamp: new Date(), type: func, message: arg, trace: getStackTrace2()[1]});
                    // doMapping(getStackTrace()).then((trace) =>{
                    // PIC.consoleLog.push({timeStamp: new Date(), type: func, message: arg, trace: trace[PIC.consoleLog.length - 1]});
                    // })
                    PIC.consoleLog.push({ timeStamp: new Date(), type: func, message: argStr, trace: getStackTrace() });
                }
                oldConsole.apply(this, arguments);
            };
        }
    }
    //Override console.log and save it all
    // (function(){
    //     var oldLog = console.log;
    //     console.log = function (message) {
    //         PIC.consoleLog += message + '\n';  
    //         //@ts-ignore
    //         oldLog.apply(console, arguments);
    //     };
    // })();
    // (function(){
    //     var oldErrLog = console.error;
    //     console.error = function (message) {
    //         PIC.consoleLog += message + '\n';  
    //         //@ts-ignore
    //         oldErrLog.apply(console, arguments);
    //     };
    // })();
    // (function(){
    //     var oldWarnLog = console.warn;
    //     console.warn = function (message) {
    //         PIC.consoleLog += message + '\n';  
    //         //@ts-ignore
    //         oldWarnLog.apply(console, arguments);
    //     };
    // })();
}
export const setLogFunctions = (window_) => {
    let workingWindow = window_ !== null && window_ !== void 0 ? window_ : window;
    if (workingWindow['_log'])
        return;
    const dt = () => {
        let date = new Date();
        return `[${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}]`;
    };
    //const funcs: (keyof Console)[] = ['assert', 'clear', 'group', 'groupCollapsed', 'groupEnd', 'log', 'table', 'time', 'timeEnd', 'timeLog', 'trace', 'warn']
    const noParamFuncs = ['assert', 'clear', 'groupEnd', 'groupCollapsed', 'table', 'time', 'timeLog', 'timeStamp', 'timeEnd'];
    const paramFunc = ['info', 'log', 'trace', 'warn', 'group'];
    //always print error?
    for (const func of noParamFuncs) {
        if (func === 'assert' || func === 'clear' || func === 'groupCollapsed' || func === 'groupEnd' || func === 'table' || func === 'time' || func === 'timeLog' || func === 'timeStamp' || func === 'timeEnd') {
            Object.defineProperty(workingWindow, `_${func}`, {
                get: function () {
                    return sessionStorage.getItem('__debug') === 'true' ? console[func].bind(window.console) : function () { };
                }
            });
        }
    }
    for (const func of paramFunc) {
        if (func === 'log' || func === 'trace' || func === 'warn' || func === 'group' || func === 'info') {
            Object.defineProperty(workingWindow, `_${func}`, {
                get: function () {
                    return sessionStorage.getItem('__debug') === 'true' ? console[func].bind(window.console, dt()) : function () { };
                }
            });
        }
    }
};
//export const assert = (condition: any, ...data: any[]) => {if (sessionStorage.getItem('__debug') === 'true') console.assert(condition, ...data)}
//export const clear = () => {if (sessionStorage.getItem('__debug') === 'true') console.clear()}
//export const group = (...data: any[]) => {if (sessionStorage.getItem('__debug') === 'true') console.group(...data)}
//export const groupCollapsed = (...data: any[]) => {if (sessionStorage.getItem('__debug') === 'true') console.groupCollapsed(...data)}
//export const groupEnd = () => {if (sessionStorage.getItem('__debug') === 'true') console.groupEnd}
//export const log = (...data: any[]) => { if (sessionStorage.getItem('__debug') === 'true') console.log(...data); }
//export const table = (tabularData: any, properties: any) => {if (sessionStorage.getItem('__debug') === 'true') console.table(tabularData, properties)}
//export const time = (label: any) => {if (sessionStorage.getItem('__debug') === 'true') console.time(label)}
//export const timeEnd = (label: any) => {if (sessionStorage.getItem('__debug') === 'true') console.timeEnd(label)}
//export const timeLog = (label: any) => {if (sessionStorage.getItem('__debug') === 'true') console.timeLog(label)}
//export const trace = (...data: any[]) => {if (sessionStorage.getItem('__debug') === 'true') console.trace(...data)}
//export const warn = (...data: any[]) => {if (sessionStorage.getItem('__debug') === 'true') console.warn(...data)}
export const setLoadingScreen = () => {
    document.body.classList.add('load-disabled');
};
export const clearLoadingScreen = () => {
    document.body.classList.remove('load-disabled');
};
export function openClientDownloadLink(iBlob, fileName) {
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(iBlob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
}
export function createBase64Url(data, mimetype = 'text/plain') {
    if (mimetype === 'pdf')
        mimetype = 'application/pdf';
    else if (mimetype === 'xlsx')
        mimetype = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    else if (mimetype === 'png')
        mimetype = 'image/png';
    else if (mimetype === 'jpg')
        mimetype = 'image/jpeg';
    return `data:${mimetype};base64,${data}`;
}
export function downloadBase64(url, fileName) {
    fetch(url)
        .then(response => response.blob())
        .then(iBlob => {
        openClientDownloadLink(iBlob, fileName);
    });
}
export function openDownloadLinkInNewTab(url) {
    let link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.click();
}
export async function fetchPrint(URL, body, fileName) {
    await fetch(URL, {
        method: 'POST',
        headers: [
            ["Content-type", "text/plain;charset=UTF-8"],
            ["picsystem", PIC.systemId]
        ],
        body: body
    }).then(res => {
        if (res.ok) {
            return res.blob();
        }
        else {
        }
    }).then((iBlob) => {
        Util.openClientDownloadLink(iBlob, fileName);
    }).catch(err => PIC.getInstance.msg('Download file has failed', err));
}
export function downloadFromDownloadSrv(response) {
    let system = PIC.systemId;
    let filename = ``;
    let notekey = '';
    let username = '';
    let timestamp = '';
    let filetype = '';
    let obj = undefined;
    try {
        obj = JSON.parse(response);
    }
    catch (error) { }
    if (typeof obj === 'object') {
        let data = obj.data;
        notekey = data.split('-')[0];
        username = data.split('-')[1];
        timestamp = data.split('-')[2].split('.')[0];
        filetype = data.split('-')[2].split('.')[1];
        if (obj.outname)
            filename = obj.outname + '.' + filetype;
        else
            filename = 'DownloadFile' + '.' + filetype;
    }
    else {
        notekey = response.split('-')[0];
        username = response.split('-')[1];
        timestamp = response.split('-')[2].split('.')[0];
        filetype = response.split('-')[2].split('.')[1];
        filename = `Vognliste.${filetype}`; //legacy reasons (bdk)
    }
    let url = `/filestore/DownloadSrv?notekey=${notekey}&username=${username}&timestamp=${timestamp}&filetype=${filetype}&system=${system}`;
    Util.fetchPrint(url, '', filename);
}
export function downloadFromPDFSrv(response) {
    let system = PIC.systemId;
    let url = `/print/getpdf?filename=${system},${response}`;
    Util.fetchPrint(url, '', `Vognliste.pdf`);
}
//# sourceMappingURL=Util.js.map